import { Button } from 'react-aria-components'
import Icon from '@/components/ui/icon'

type ModalHeaderProps = {
  title?: string
  subtitle?: string
  showClose?: boolean
}

export default function ModalHeader({
  title,
  subtitle,
  showClose = true,
}: ModalHeaderProps): JSX.Element {
  return (
    <header className="flex items-center justify-between gap-l border-b border-grey-300 p-m m:px-s">
      <div>
        {title ? <h6 className="h4 mb-0">{title}</h6> : null}
        {subtitle ? <p className="mt-xxxs text-14 text-grey-700">{subtitle}</p> : null}
      </div>

      {showClose ? (
        <Button slot="close" className="hover:text-primary">
          <Icon id="icon-modal-close" width={16} height={16} aria-hidden="true" />
          <span className="sr-only">Close this window</span>
        </Button>
      ) : null}
    </header>
  )
}
